/* eslint-disable max-len */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { useScreenClass } from "react-grid-system";
import styled from "styled-components";
import { Col, Row } from "../../components/StyledGridSystem";
import StyledTable from "../../components/StyledTable";
import StyledEvent from "../../components/StyledEvent";
import axios from "axios";
import { UserContext } from "../../context/UserContext";
import {
  generateDates,
  generateHeaderwidth,
  generateOptionalCalendar,
  generateOptionalCalendarRecommmend,
  generateRecommendCalendar,
} from "../../hooks/generateCalendar";
import { SemesterContext } from "../../context/SemesterContext";
import MultiEvent from "../../components/MultiEvent";
import LoadingSpinner from "../../components/LoadingSpinner";
import ConfirmModal from "../../components/ConfirmModal";
import RecommendedRoadmapDetail from "../../components/RecommendedRoadmapDetail";
import SnackBar from "../../components/SnackBar";
import { convertToSelect } from "../../hooks/useScript";
import { CustomFlex } from "./RoadMapTimeline";
import { FlexGrow } from "../../components/FlexBox";
import ViewSelect from "../../components/ViewSelect";
import moment from "moment";
import { Icon } from "@mui/material";
import CompetencyAddModalNew from "../../components/CompetencyAddModalNew";
import AdoptDetail from "./AdoptDetail";
import { handleJWTError } from "../../hooks/jwtErrHandler";
import PersonalizedRoadMapSection, {
  getDefaultMinFitScore,
} from "./PersonalizedRoadMapSection";
const CustomRow = styled(Row)`
  margin-bottom: 0px;
  height: calc(100vh - 84px);
  height: -moz-calc(100vh - 84px);
  height: -o-calc(100vh - 84px);
  height: -webkit-calc(100vh - 84px);
`;
const TabWrapper = styled.div`
  display: flex;
  // padding: 6px 8px 0;
  // border-bottom: 1px solid #4d4d4d;
  background: #000920;
`;
const TabButton = styled.button<{ active: boolean }>`
  min-width: 220px;
  padding: 10px 20px;
  border-radius: 6px 6px 0 0;
  border: 1px solid ${({ active }) => (active ? "#c54b4d" : "#868686")};
  background: ${({ active }) => (active ? "#c54b4d" : "#000")};
  color: #fff;
  font-family: Inter, sans-serif;
  font-size: 18px;
  font-weight: 700;
  cursor: pointer;
`;

const ActionButton = styled.button`
display: flex;
justify-content: center;
align-items: center;
margin-bottom: 10px;
// width: 100%;
gap: 8px;
  border: 1px solid #2f66ff;
  background: linear-gradient(180deg, #2868ff 0%, #1645d7 100%);
  color: #fff;
  border-radius: 6px;
  padding: 10px 24px;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  &:disabled {
    opacity: 0.65;
    cursor: not-allowed;
  }
`;

type RoadmapData = {
  label: string;
  value: string;
  credits: number;
  curriculum_version: number;
  id: string;
  milestone_groups: any;
  semester: string;
  term_ordinal: number;
  title: string;
  year: number;
};

function parseFiniteNumberInput(raw: string): number | null {
  const t = raw.trim();
  if (t === "") return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : null;
}

function RecommendedRoadMapPage() {
  const screenClass = useScreenClass();
  const [modalOpen, setModalOpen] = React.useState(false);
  const userContext = useContext(UserContext);
  const [loading, setLoading] = useState<boolean>(false);
  const [dates, setDates] = useState<Array<any>>([]);
  const [roadmapData, setRoadmapData] = useState<Array<RoadmapData>>([]);
  const [selectedRoadmap, setSelectedRoadmap] = useState<any>();
  const [requiredWidth, setRequiredWidth] = useState<string>("");
  const [optionalWidth, setOptionalWidth] = useState<string>("");
  const [requiredEvents, setRequiredEvents] = useState<Array<any>>([]);
  const [optionalEvents, setOptionalEvents] = useState<Array<any>>([]);
  const currentUser = useContext(UserContext).user;
  const semesterContext = useContext(SemesterContext);
  const [isSnackbarOpen, setIsSnackbarOpen] = useState<boolean>(false);
  const [isErrorOpen, setIsErrorOpen] = useState<boolean>(false);
  const [isWarningOpen, setIsWarningOpen] = useState<boolean>(false);
  const [message, setMessage] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [confirm, setConfirm] = useState<boolean>(false);
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [selectedCompetency, setSelectedCompetency] = useState<any>({});
  const [currentView, setCurrentView] = useState<"week" | "month">("month");
  const [enrolled, setEnrolled] = useState<boolean>(true);
  const [cancelTokenSource, setCancelTokenSource] = useState(
    axios.CancelToken.source()
  );
  const [noDataMessage, setNoDataMessage] = useState("");
  const [studentVersion, setStudentVersion] = useState(0);
  const [roadMapDetail, setRoadmapDetail] = useState<any>(null);
  const [adoptInfo, setAdoptInfo] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<"cohort" | "personalized">(
    "cohort"
  );
  const [weightType, setWeightType] = useState("balanced");
  const [competencyWeight, setCompetencyWeight] = useState("");
  const [interestWeight, setInterestWeight] = useState("");
  const [progressWeight, setProgressWeight] = useState("");
  const [maxCredits, setMaxCredits] = useState(60);

  const [minFitScore, setMinFitScore] = useState(
    getDefaultMinFitScore("balanced")
  );
  const [preferredTheme, setPreferredTheme] = useState("none");
  const [maxSets, setMaxSets] = useState(3);
  const [isGeneratingPersonalized, setIsGeneratingPersonalized] =
    useState(false);
  const [isPersonalizedGenerated, setIsPersonalizedGenerated] = useState(false);
  const [personalizedNoDataMessage, setPersonalizedNoDataMessage] =
    useState("");
  const [personalizedRoadmapData, setPersonalizedRoadmapData] = useState<
    Array<RoadmapData>
  >([]);
  const [selectedPersonalizedRoadmap, setSelectedPersonalizedRoadmap] =
    useState<any>();
  const [personalizedRequiredWidth, setPersonalizedRequiredWidth] =
    useState<string>("");
  const [personalizedOptionalWidth, setPersonalizedOptionalWidth] =
    useState<string>("");
  const [personalizedRequiredEvents, setPersonalizedRequiredEvents] = useState<
    Array<any>
  >([]);
  const [personalizedOptionalEvents, setPersonalizedOptionalEvents] = useState<
    Array<any>
  >([]);

  const isLarge = useMemo(() => ["xxl"].includes(screenClass), [screenClass]);
  const isMobile = useMemo(
    () => ["xs", "sm"].includes(screenClass),
    [screenClass]
  );
  const personalizedGenerateDisabled = useMemo(() => {
    if (isGeneratingPersonalized) return true;
    if (!Number.isFinite(maxCredits) || maxCredits < 1 || maxCredits > 60) return true;
    if (weightType !== "custom") return false;
    const c = parseFiniteNumberInput(competencyWeight);
    const i = parseFiniteNumberInput(interestWeight);
    const p = parseFiniteNumberInput(progressWeight);
    if (c === null || i === null || p === null) return true;
    const sum = Math.round((c + i + p) * 1e6) / 1e6;
    return sum !== 1;
  }, [
    isGeneratingPersonalized,
    maxCredits,
    weightType,
    competencyWeight,
    interestWeight,
    progressWeight,
  ]);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      try {
        cancelTokenSource.cancel();

        // Create a new CancelToken source for the current request
        const newCancelTokenSource = axios.CancelToken.source();
        setCancelTokenSource(newCancelTokenSource);

        // await fetchRecommended(newCancelTokenSource);
        await fetchStatus(newCancelTokenSource);
      } catch (err) {
        handleJWTError(err);
        if (axios.isCancel(err)) {
          // Request was canceled, ignore
        } else {
          setLoading(false);
        }
      }
    };
    fetchData();

    return () => {
      // Cleanup: Cancel ongoing request when component unmounts
      cancelTokenSource.cancel();
    };
  }, [currentUser, semesterContext, userContext]);

  useEffect(() => {
    if (activeTab !== "personalized") return;
    setIsPersonalizedGenerated(false);
    setPersonalizedRoadmapData([]);
    setSelectedPersonalizedRoadmap(undefined);
    setPersonalizedRequiredEvents([]);
    setPersonalizedOptionalEvents([]);
    setPersonalizedNoDataMessage("");
  }, [semesterContext.selectedSemester?.label]);

  useEffect(() => {
    if (!isPersonalizedGenerated) return;
    if (!selectedPersonalizedRoadmap) return;
    mapPersonalizedData(selectedPersonalizedRoadmap);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext.timeView.value]);

  const fetchCompetencyDetail = async (event: any) => {
    if (studentVersion) {
      await axios
        .get(
          `/competency/detail?competency_code=${event.competency_code}&university_code=CMKL&curriculum_version=${studentVersion}&semester_name=${semesterContext.selectedSemester.label}`
        )
        .then((res) => {
          setRoadmapDetail(res.data.competency);
        })
        .catch((err: any) => {
          handleJWTError(err);
          setRoadmapDetail(null);
          setErrorMessage(
            err?.response?.data?.error ||
            `Competency: ${event.competency_code} not exists!`
          );
          setIsErrorOpen(true);
        });
    }
  };

  const fetchStatus = async (newCancelTokenSource: any) => {
    const storedRole = localStorage.getItem("role");
    const initialRole = JSON.parse(storedRole as string);

    if (semesterContext.selectedSemester.label)
      axios
        .get(
          `/student/semester/status?student_id=${initialRole.role_id}&program_id=${userContext.user?.programs?.[0]?.id}&semester_name=${semesterContext.selectedSemester.label}`,
          { cancelToken: newCancelTokenSource.token }
        )
        .then((res) => {
          if (res.data.data) {
            fetchRecommended(
              newCancelTokenSource,
              res.data.data[0].student_term_ordinal
            );
          } else {
            setEnrolled(false);
          }
        })
        .catch((error) => {
          console.log("Error fetching enrollment status:", error);
          handleJWTError(error);
          setLoading(false);

          const earliest = moment(semesterContext.selectedSemester.start_date)
            .startOf("month")
            .format("YYYY-MM-DD");
          const latest = moment(semesterContext.selectedSemester.end_date)
            .endOf("month")
            .format("YYYY-MM-DD");
          setDates(
            generateDates(
              earliest,
              latest,
              userContext.timeView.value,
              isLarge ? 13 : 7,
              {
                add_drop_date: semesterContext.selectedSemester.add_drop_date,
                final_assess_date:
                  semesterContext.selectedSemester.final_assess_date,
                final_recording_date:
                  semesterContext.selectedSemester
                    .competency_recording_deadline,
              }
            )
          );
          // setSelectedRoadmap(undefined);
          setRoadmapData([]);
          setRequiredWidth("400px");
          setRequiredEvents([]);
          setOptionalEvents([]);
        });
  };

  const fetchRecommended = async (
    newCancelTokenSource: any,
    term_ordinal: number
  ) => {
    const storedRole = localStorage.getItem("role");
    const initialRole = JSON.parse(storedRole as string);
    setNoDataMessage("");
    setLoading(true);
    setEnrolled(true);

    // const first_term_ordinal =
    //   semesterContext.semesters.find(
    //     (sem: any) => sem.label === currentUser.first_term
    //   )?.term_ordinal || 1;
    // const selected_term_ordinal = semesterContext.selectedSemester.term_ordinal;

    // const adjusted_term_ordinal =
    //   selected_term_ordinal - first_term_ordinal + 1;

    const selectedRoadmapIndex = roadmapData?.findIndex((v: any) => v.id === selectedRoadmap?.id)

    if (semesterContext.selectedSemester.label)
      await axios
        .get(
          `/student/version?student_id=${initialRole.role_id}&semester_name=${semesterContext.selectedSemester.label}&program_id=${userContext?.user?.programs?.[0]?.id}`
        )
        .then((res) => {
          setStudentVersion(res.data.version.curriculum_version);
          axios
            .get(
              `/roadmap/milestones/recommended?student_id=${currentUser.id}&year=${semesterContext.selectedSemester.year}&semester=${semesterContext.selectedSemester.label}&curriculum_version=${res.data.version.curriculum_version}&term_ordinal=${term_ordinal}`
            )
            .then((res) => {
              if (res.data.recommended_roadmaps) {
                setRoadmapData(
                  convertToSelect(res.data.recommended_roadmaps, "title", "id")
                );
                mapData(
                  res.data.recommended_roadmaps[
                  selectedRoadmapIndex === -1 ? 0 : selectedRoadmapIndex
                  ]
                );
              } else {
                // const earliest = semesterContext.selectedSemester.start_date;
                // const latest = semesterContext.selectedSemester.end_date;
                const earliest = moment(
                  semesterContext.selectedSemester.start_date
                )
                  .startOf("month")
                  .format("YYYY-MM-DD");
                const latest = moment(semesterContext.selectedSemester.end_date)
                  .endOf("month")
                  .format("YYYY-MM-DD");
                setDates(
                  generateDates(
                    earliest,
                    latest,
                    userContext.timeView.value,
                    isLarge ? 13 : 7,
                    {
                      add_drop_date:
                        semesterContext.selectedSemester.add_drop_date,
                      final_assess_date:
                        semesterContext.selectedSemester.final_assess_date,
                      final_recording_date:
                        semesterContext.selectedSemester
                          .competency_recording_deadline,
                    }
                  )
                );
                // setSelectedRoadmap(undefined);
                setRoadmapData([]);
                setRequiredWidth("400px");
                setRequiredEvents([]);
                setOptionalEvents([]);
                setLoading(false);
              }
            })
            .catch((err: any) => {
              handleJWTError(err);
              if (err?.response?.data?.error) {
                setNoDataMessage(err.response.data.error);
              }
              const earliest = moment(semesterContext.selectedSemester.start_date)
                .startOf("month")
                .format("YYYY-MM-DD");
              const latest = moment(semesterContext.selectedSemester.end_date)
                .endOf("month")
                .format("YYYY-MM-DD");
              setDates(
                generateDates(
                  earliest,
                  latest,
                  userContext.timeView.value,
                  isLarge ? 13 : 7,
                  {
                    add_drop_date: semesterContext.selectedSemester.add_drop_date,
                    final_assess_date:
                      semesterContext.selectedSemester.final_assess_date,
                    final_recording_date:
                      semesterContext.selectedSemester
                        .competency_recording_deadline,
                  }
                )
              );
              setSelectedRoadmap(undefined);
              setRoadmapData([]);
              setRequiredWidth("400px");
              setRequiredEvents([]);
              setOptionalEvents([]);
              setLoading(false);
            });
        })
        .catch((error) => {
          handleJWTError(error);
          setEnrolled(false);
        });
    setLoading(false);
  };
  const extractRoadmaps = (payload: any): Array<RoadmapData> => {
    return (
      payload?.recommended_roadmaps ||
      payload?.roadmaps ||
      payload?.recommendations ||
      payload?.data?.recommended_roadmaps ||
      []
    );
  };

  const toRoadmapSelect = (roadmaps: Array<RoadmapData>) => {
    return roadmaps.map((roadmap: any, index: number) => ({
      ...roadmap,
      id: roadmap.id || `roadmap-${index + 1}`,
      title: roadmap.title || roadmap.name || `Roadmap ${index + 1}`,
      credits: roadmap.credits || roadmap.total_credits || 0,
      milestone_groups: roadmap.milestone_groups || roadmap.milestones || [],
    }));
  };

  const buildRoadmapEvents = (
    roadmap: any,
    setRoadmap: (value: any) => void,
    setReqWidth: (value: string) => void,
    setOptWidth: (value: string) => void,
    setReqEvents: (value: Array<any>) => void,
    setOptEvents: (value: Array<any>) => void,
    setEmptyMessage: (value: string) => void
  ) => {
    setLoading(true);

    const rawAverageScore = roadmap?.average_score;
    const avgScoreNum =
      rawAverageScore === undefined ||
        rawAverageScore === null ||
        rawAverageScore === ""
        ? NaN
        : Number(rawAverageScore);

    const formattedAverageScore = Number.isFinite(avgScoreNum)
      ? avgScoreNum.toFixed(5)
      : undefined;

    roadmap?.milestone_groups
      ? setRoadmap({
        label: roadmap.title,
        value: roadmap.id,
        credits: roadmap.credits,
        average_score: formattedAverageScore,
        id: roadmap.id,
        milestone_groups: roadmap?.milestone_groups || [],
        semester: roadmap.semester,
        term_ordinal: roadmap.term_ordinal,
        title: roadmap.title,
        year: roadmap.year,
        curriculum_version: roadmap.curriculum_version,
      })
      : setEmptyMessage("No Recommended Roadmap Found!");

    const customArray: any[] = [];
    (roadmap.milestone_groups || []).forEach((group: any) => {
      if (!group.milestones) {
        return;
      } else if (group.milestones.length > 1) {
        customArray.push({
          curriculum_version: roadmap.curriculum_version,
          isMulti: true,
          children: group.milestones,
          ...group.milestones[0],
        });
      } else {
        customArray.push({
          isMulti: false,
          curriculum_version: roadmap.curriculum_version,
          ...group.milestones[0],
        });
      }
    });

    const earliest = moment(semesterContext.selectedSemester.start_date)
      .startOf("month")
      .format("YYYY-MM-DD");
    const latest = moment(semesterContext.selectedSemester.end_date)
      .endOf("month")
      .format("YYYY-MM-DD");
    const requiredLength = customArray.filter((el: any) => el.required);
    const optionalLength = customArray.filter((el: any) => !el.required);
    setReqWidth(generateHeaderwidth(requiredLength.length));
    setOptWidth(generateHeaderwidth(optionalLength.length));
    setDates(
      generateDates(
        earliest,
        latest,
        userContext.timeView.value,
        isLarge ? 13 : 7,
        {
          add_drop_date: semesterContext.selectedSemester.add_drop_date,
          final_assess_date: semesterContext.selectedSemester.final_assess_date,
          final_recording_date:
            semesterContext.selectedSemester.competency_recording_deadline,
        }
      )
    );
    setReqEvents(
      generateRecommendCalendar(requiredLength?.sort((a: any, b: any) =>
        a.competency_code?.localeCompare(b.competency_code)), earliest, userContext.timeView.value)
    );
    setOptEvents(
      generateOptionalCalendarRecommmend(
        optionalLength?.sort((a: any, b: any) =>
          a.competency_code?.localeCompare(b.competency_code)),
        earliest,
        requiredLength?.length,
        userContext.timeView.value
      )
    );
    setLoading(false);
  };
  const mapData = (roadmap: RoadmapData) => {
    buildRoadmapEvents(
      roadmap,
      setSelectedRoadmap,
      setRequiredWidth,
      setOptionalWidth,
      setRequiredEvents,
      setOptionalEvents,
      setNoDataMessage
    );
  };

  const mapPersonalizedData = (roadmap: any) => {

    const flattenedRoadmap = roadmap
      ? {
        ...roadmap,
        milestone_groups: (roadmap.milestone_groups || []).flatMap(
          (group: any) => {
            const { milestones: _nested, ...groupFallback } = group || {};
            return (group?.milestones || []).map((milestone: any) => ({
              ...group,
              milestones: [
                {
                  ...groupFallback,
                  ...milestone,
                },
              ],
            }));
          }
        ),
      }
      : roadmap;

    (flattenedRoadmap?.milestone_groups || []).forEach(
      (g: any, gi: number) => {
        const m = g?.milestones?.[0];
      }
    );

    buildRoadmapEvents(
      flattenedRoadmap,
      setSelectedPersonalizedRoadmap,
      setPersonalizedRequiredWidth,
      setPersonalizedOptionalWidth,
      setPersonalizedRequiredEvents,
      setPersonalizedOptionalEvents,
      setPersonalizedNoDataMessage
    );
  };
  const handlePersonalizedEventClick = (event: any) => {
    setSelectedCompetency(event);
    setIsModalOpen(true);
    fetchCompetencyDetail(event);
  };
  const adoptPath = () => {
    if (activeTab === "cohort") {
      const selectedEventId: Array<string> = [];
      setLoading(true);
      requiredEvents.forEach((element) => {
        if (element.isMulti) {
          element.children.forEach((child: { selected: boolean; id: string }) => {
            if (child.selected) {
              selectedEventId.push(child.id);
            }
          });
        } else {
          selectedEventId.push(element.id);
        }
      });
      optionalEvents.forEach((element) => {
        if (element.isMulti) {
          element.children.forEach((child: { selected: boolean; id: string }) => {
            if (child.selected) {
              selectedEventId.push(child.id);
            }
          });
        } else {
          selectedEventId.push(element.id);
        }
      });
      axios
        .post("/roadmap/milestones/adopt", {
          student_id: currentUser.id,
          milestone_ids: selectedEventId,
          recommended_roadmap_id: selectedRoadmap?.id,
          year: Number(selectedRoadmap?.year),
          semester: selectedRoadmap?.semester,
        })
        .then((res: any) => {
          setLoading(false);
          if (res.data.roadmaps.message && res.data.roadmaps.message !== "") {
            // setErrorMessage(res.data.roadmaps.message);
            // setIsWarningOpen(true);

            setAdoptInfo(res.data.roadmaps.message);
          } else {
            setMessage("Adopted the roadmap successfully!");
            setIsSnackbarOpen(true);
          }
          setConfirm(false);
        })
        .catch(function (error) {
          handleJWTError(error);
          setLoading(false);
          setConfirm(false);
          if (error.response) {
            setErrorMessage(
              error.response.data.error || "Failed to adopt roadmap!"
            );
            setIsErrorOpen(true);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        });
    } else if (activeTab === "personalized") {
      const selectedCometencies: Array<string> = [];
      setLoading(true);
      personalizedRequiredEvents.forEach((element) => {
        if (element.isMulti) {
          element.children.forEach((child: { selected: boolean; id: string, competency_code: string }) => {
            if (child.selected) {
              selectedCometencies.push(child.competency_code);
            }
          });
        } else {
          selectedCometencies.push(element.competency_code);
        }
      });
      personalizedOptionalEvents.forEach((element) => {
        if (element.isMulti) {
          element.children.forEach((child: { selected: boolean; id: string, competency_code: string }) => {
            if (child.selected) {
              selectedCometencies.push(child.competency_code);
            }
          });
        } else {
          selectedCometencies.push(element.competency_code);
        }
      });
      axios
        .post("/roadmap/recommendation/personalized/adopt", {
          student_id: currentUser.id,
          semester_name: selectedRoadmap?.semester,
          curriculum_version: selectedRoadmap?.curriculum_version,
          competencies: selectedCometencies,
        }).then((res: any) => {
          setLoading(false);
          if (res.data.roadmap.message && res.data.roadmap.message !== "") {
            // setErrorMessage(res.data.roadmaps.message);
            // setIsWarningOpen(true);

            setAdoptInfo(res.data.roadmap.message);
          } else {
            setMessage("Adopted the roadmap successfully!");
            setIsSnackbarOpen(true);
          }
          setConfirm(false);
        })
        .catch(function (error) {
          handleJWTError(error);
          setLoading(false);
          setConfirm(false);
          if (error.response) {
            setErrorMessage(
              error.response.data.error || "Failed to adopt roadmap!"
            );
            setIsErrorOpen(true);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
        });
    }
  };

  const generatePersonalizedRecommendations = async () => {
    try {
      setIsGeneratingPersonalized(true);
      setPersonalizedNoDataMessage("");

      let competencyWeightNum: number | undefined;
      let interestWeightNum: number | undefined;
      let progressWeightNum: number | undefined;
      if (weightType === "custom") {
        const c = parseFiniteNumberInput(competencyWeight);
        const i = parseFiniteNumberInput(interestWeight);
        const p = parseFiniteNumberInput(progressWeight);
        if (c === null || i === null || p === null) {
          setPersonalizedNoDataMessage(
            "Enter valid numbers for competency, interest, and progress weights."
          );
          setIsGeneratingPersonalized(false);
          return;
        }
        const sum = Math.round((c + i + p) * 1e6) / 1e6;
        if (sum !== 1) {
          setPersonalizedNoDataMessage(
            `Total weight must equal 1. Current total: ${sum}.`
          );
          setIsGeneratingPersonalized(false);
          return;
        }
        competencyWeightNum = c;
        interestWeightNum = i;
        progressWeightNum = p;
      }

      const payload: Record<string, unknown> = {
        student_id: currentUser.id,
        semester: semesterContext.selectedSemester.label,
        max_credit_load: maxCredits,
        previous_semester: "ALL",
        max_sets: maxSets,
        preferred_theme: preferredTheme === "none" ? "" : preferredTheme,
        weight_type: weightType === "custom" ? "custom" : weightType,
      };
      if (
        competencyWeightNum !== undefined &&
        interestWeightNum !== undefined &&
        progressWeightNum !== undefined
      ) {
        payload.competency_weight = competencyWeightNum;
        payload.interest_weight = interestWeightNum;
        payload.progress_weight = progressWeightNum;
      }

      const minFitScoreNum = parseFiniteNumberInput(minFitScore);
      if (minFitScoreNum !== null) {
        payload.min_fit_score = minFitScoreNum;
      }

      const response = await axios.post(
        "https://a1ce-recommender-staging.cmkl.ac.th/api/v1/recommendations",
        payload
      );

      const warningMessage: string | undefined = response?.data?.warning;
      const rawRoadmaps = extractRoadmaps(response.data);
      const normalizedRoadmaps = toRoadmapSelect(rawRoadmaps).map(
        (roadmap: any) => ({
          ...roadmap,
          curriculum_version:
            roadmap.curriculum_version || studentVersion || 0,
        })
      );
      const visibleRoadmaps = normalizedRoadmaps.slice(0, maxSets);

      if (warningMessage && visibleRoadmaps.length === 0) {
        setPersonalizedRoadmapData([]);
        setSelectedPersonalizedRoadmap(undefined);
        setPersonalizedRequiredEvents([]);
        setPersonalizedOptionalEvents([]);
        setPersonalizedNoDataMessage("");
        setIsPersonalizedGenerated(false);
        setErrorMessage(warningMessage);
        setIsWarningOpen(true);
        return;
      }

      if (visibleRoadmaps.length === 0) {
        setPersonalizedRoadmapData([]);
        setSelectedPersonalizedRoadmap(undefined);
        setPersonalizedNoDataMessage("No personalized recommendations found.");
        setIsPersonalizedGenerated(true);
        return;
      }

      const tableRows = visibleRoadmaps.map((roadmap: any) => ({
        ...roadmap,
        label: roadmap.title,
        value: roadmap.id,
      }));
      setPersonalizedRoadmapData(tableRows);

      const selectedIdx = tableRows.findIndex(
        (v: any) => v.id === selectedPersonalizedRoadmap?.id
      );
      const index = selectedIdx === -1 ? 0 : selectedIdx;
      mapPersonalizedData(tableRows[index]);
      setIsPersonalizedGenerated(true);

      if (warningMessage) {
        setErrorMessage(warningMessage);
        setIsWarningOpen(true);
      }
    } catch (error: any) {
      handleJWTError(error);
      console.log('err', error.response.data.message);
      setErrorMessage(error.response.data.message);
      setIsErrorOpen(true);
    } finally {
      setIsGeneratingPersonalized(false);
    }
  };

  if (!enrolled) {
    return (
      <CustomRow wrap="nowrap">
        <Col style={{ padding: 0, background: "#000920" }}>
          <StyledTable
            data={[]}
            selectedData={[]}
            dateRange={[
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
              {
                assess_date: "",
                date: " ",
                exact_date: "",
                final_assess_date: false,
                final_recording_date: false,
              },
            ]}
            timeline={true}
            requiredWidth={requiredWidth}
            optionalWidth={optionalWidth}
            reMapData={mapData}
            onConfirm={() => {
              setConfirm(true);
            }}
          >
            <div
              style={{
                background:
                  "linear-gradient(90deg, rgb(176, 52, 52) 0%, rgb(24, 75, 104) 118.29%)",
                position: "fixed",
                top: 300,
                left: "40%",
                color: "rgb(255 255 255)",
                fontFamily: "Inter",
                // fontSize: "24px",
                padding: "24px 48px",
                borderRadius: 10,
                // border: "1px solid gray",
                boxShadow: "0 4px 4px rgba(0, 0, 0, 0.17)",
              }}
            >
              Student not enrolled for {semesterContext.selectedSemester.label}
            </div>
          </StyledTable>
        </Col>
      </CustomRow>
    );
  }

  return (
    <>
      {roadMapDetail && (
        <CompetencyAddModalNew
          isWarningOpen={false}
          setIsWarningOpen={() => { }}
          hideAddButton
          isStudent={true}
          isAddModalOpen={isModalOpen}
          setAddModalOpen={setIsModalOpen}
          // parentData={{}}
          data={roadMapDetail}
          onAddComplete={() => { }}
          onAddError={() => { }}
        />
      )}
      {adoptInfo && (
        <AdoptDetail
          title="Adopt Roadmap Detail"
          isOpen={adoptInfo}
          setAdoptInfo={setAdoptInfo}
          info={adoptInfo}
        />
      )}
      <ConfirmModal
        isDisabled={loading}
        title="Adopt Roadmap Milestone"
        description={
          <div>
            {/* <Icon
              title="Required for graduation"
              sx={{
                color: "yellow",
                paddingRight: "5px",
                // boxShadow: "0 4px 4px #0000007a",
              }}
            >
              warning
            </Icon> */}
            Please note that some of the competencies in this recommended
            roadmap may have prerequisites. Review the individual competencies
            for details You must have completed and recorded all prerequisite
            competencies before you will be allowed to record dependent
            competencies.
            <br />
            <br />
            Continue adopting the recommended roadmap?
          </div>
        }
        setOpen={setConfirm}
        isOpen={confirm}
        confirmFunction={() => {
          !loading && adoptPath();
        }}
      />
      <SnackBar
        isOpen={isSnackbarOpen}
        setOpen={setIsSnackbarOpen}
        message={message}
        type="success"
        link
      />
      <SnackBar
        isOpen={isErrorOpen}
        setOpen={setIsErrorOpen}
        header="Error!"
        message={errorMessage}
        type="error"
      />
      <SnackBar
        isOpen={isWarningOpen}
        setOpen={setIsWarningOpen}
        header="Warning!"
        message={errorMessage}
        type="warning"
      />
      <CustomFlex
        $sidebarOpen={userContext.roadmapView.sidebar}
        $isMobile={isMobile}
      >
        <FlexGrow style={{ flexGrow: "0", whiteSpace: "nowrap" }}>
          <>
            <ViewSelect />
          </>
        </FlexGrow>
      </CustomFlex>
      <CustomRow wrap="nowrap">
        <Col
          style={{
            padding: 0,
            background: "#000920",
            display: "flex",
            flexDirection: "column",
            minHeight: 0,
            height: "100%",
          }}
        >
          <TabWrapper style={{ marginLeft: 24, marginRight: 24, display: 'flex', justifyContent: 'space-between', flexShrink: 0 }}>
            {/* <div>
              <TabButton
                type="button"
                active={activeTab === "cohort"}
                onClick={() => setActiveTab("cohort")}
              >
                By Study Year
              </TabButton>
              <TabButton
                type="button"
                active={activeTab === "personalized"}
                onClick={() => setActiveTab("personalized")}
              >
                Personalized
              </TabButton></div> */}
            {/* {isPersonalizedGenerated &&
              <ActionButton
                style={{ width: "fit-content" }}
                type="button"
                onClick={() => setIsPersonalizedGenerated(false)}
              >
                <Icon>settings</Icon> Change Settings
              </ActionButton>} */}
          </TabWrapper>

          <div
            style={{
              flex: 1,
              minHeight: 0,
              display: "flex",
              flexDirection: "column",
            }}
          >
            {activeTab === "cohort" ? (
              noDataMessage !== "" ? (
                <StyledTable
                  data={roadmapData}
                  selectedData={selectedRoadmap}
                  dateRange={dates}
                  timeline={false}
                  requiredWidth={requiredWidth}
                  optionalWidth={optionalWidth}
                  reMapData={mapData}
                  onConfirm={() => {
                    setConfirm(true);
                  }}
                >
                  <div
                    style={{
                      background:
                        "linear-gradient(90deg, rgb(176, 52, 52) 0%, rgb(24, 75, 104) 118.29%)",
                      position: "fixed",
                      top: 300,
                      left: "40%",
                      color: "rgb(255 255 255)",
                      fontFamily: "Inter",
                      // fontSize: "24px",
                      padding: "24px 48px",
                      borderRadius: 10,
                      boxShadow: "0 4px 4px rgba(0, 0, 0, 0.17)",
                    }}
                  >
                    {noDataMessage}
                  </div>
                </StyledTable>
              ) : loading ? (
                <LoadingSpinner />
              ) : (
                <StyledTable
                  data={roadmapData}
                  selectedData={selectedRoadmap}
                  dateRange={dates}
                  timeline={false}
                  requiredWidth={requiredWidth}
                  optionalWidth={optionalWidth}
                  reMapData={mapData}
                  onConfirm={() => {
                    setConfirm(true);
                  }}
                >
                  {requiredEvents.map((event: any, key: number) => (
                    <>
                      {!event.isMulti ? (
                        <StyledEvent
                          key={key}
                          onItemClick={() => {
                            setSelectedCompetency(event);
                            setIsModalOpen(true);
                            fetchCompetencyDetail(event);
                          }}
                          title={event.title}
                          description={event.description}
                          startDate={event.startDate}
                          endDate={event.endDate}
                          left={event.left}
                          top={event.top}
                          height={event.height}
                          backgroundColor={event.backgroundColor || "red"}
                          fontColor={event.fontColor}
                          skills={event.skills}
                          credits={event.credits}
                          competency_code={event.competency_code}
                        />
                      ) : (
                        <MultiEvent eventData={event} />
                      )}
                    </>
                  ))}
                  {optionalEvents.map((event: any, key: number) => (
                    <>
                      {!event.isMulti ? (
                        <StyledEvent
                          key={key}
                          onItemClick={() => {
                            setSelectedCompetency(event);
                            setIsModalOpen(true);
                            fetchCompetencyDetail(event);
                          }}
                          title={event.title}
                          description={event.description}
                          startDate={event.startDate}
                          endDate={event.endDate}
                          left={event.left}
                          top={event.top}
                          height={event.height}
                          backgroundColor={event.backgroundColor || "blue"}
                          fontColor={event.fontColor}
                          skills={event.skills}
                          credits={event.credits}
                          competency_code={event.competency_code}
                        />
                      ) : (
                        <MultiEvent eventData={event} />
                      )}
                    </>
                  ))}
                </StyledTable>
              )
            ) : (
              <PersonalizedRoadMapSection
                isPersonalizedGenerated={isPersonalizedGenerated}
                isGeneratingPersonalized={isGeneratingPersonalized}
                personalizedNoDataMessage={personalizedNoDataMessage}
                weightType={weightType}
                competencyWeight={competencyWeight}
                setCompetencyWeight={setCompetencyWeight}
                interestWeight={interestWeight}
                setInterestWeight={setInterestWeight}
                progressWeight={progressWeight}
                setProgressWeight={setProgressWeight}
                maxCredits={maxCredits}
                setMaxCredits={setMaxCredits}
                minFitScore={minFitScore}
                setMinFitScore={setMinFitScore}
                personalizedGenerateDisabled={personalizedGenerateDisabled}
                preferredTheme={preferredTheme}
                maxSets={maxSets}
                personalizedRoadmapData={personalizedRoadmapData}
                selectedPersonalizedRoadmap={selectedPersonalizedRoadmap}
                dates={dates}
                personalizedRequiredWidth={personalizedRequiredWidth}
                personalizedOptionalWidth={personalizedOptionalWidth}
                personalizedRequiredEvents={personalizedRequiredEvents}
                personalizedOptionalEvents={personalizedOptionalEvents}
                setWeightType={setWeightType}
                setPreferredTheme={setPreferredTheme}
                setMaxSets={setMaxSets}
                setIsPersonalizedGenerated={setIsPersonalizedGenerated}
                generatePersonalizedRecommendations={
                  generatePersonalizedRecommendations
                }
                mapPersonalizedData={mapPersonalizedData}
                onConfirm={() => {
                  setConfirm(true);
                }}
                onEventClick={handlePersonalizedEventClick}
              />
            )}
          </div>
        </Col>
      </CustomRow>
    </>
  );
}
export default RecommendedRoadMapPage;
